import { ApiProperty } from '@nestjs/swagger';

export class LiquidacionVdExcelRowDto {
  @ApiProperty({ example: 'NORTE EUROPA' })
  trafico!: string;

  @ApiProperty({ example: 'EXPORTADORA ACOGRAPES LIMITADA' })
  exportador!: string;

  @ApiProperty({ example: 'MAERSK CHILE S.A.' })
  naviera!: string;

  @ApiProperty({ example: 'JPO PISCES' })
  nave!: string;

  @ApiProperty({ example: '507' })
  viaje!: string;

  @ApiProperty({ example: '2025-02-20' })
  fechaEmbarque!: string; // ISO yyyy-mm-dd

  @ApiProperty({ example: 'VALPARAISO' })
  embarque!: string; // POL

  @ApiProperty({ example: 'ROTTERDAM' })
  descarga!: string; // POD

  @ApiProperty({ example: 'FRUTA FRESCA' })
  grupoEspecie!: string;

  @ApiProperty({ example: 'FRESH GRAPES' })
  especie!: string;

  @ApiProperty({ example: '250135606' })
  booking!: string;

  @ApiProperty({ example: '250135606' })
  bl!: string;

  @ApiProperty({ example: 'MNBU3052784' })
  contenedor!: string;

  @ApiProperty({ example: 1 })
  cantidad!: number;

  /** Tarifa pública en USD (entero sin decimales) */
  @ApiProperty({ example: 3573, description: 'Tarifa pública USD (entero)' })
  tarifaPublica!: number;

  /** Tarifa neta en USD (entero sin decimales) */
  @ApiProperty({ example: 3668, description: 'Tarifa neta USD (entero)' })
  tarifaNeta!: number;

  /** Valor declarado en USD (entero sin decimales) */
  @ApiProperty({ example: -95, description: 'VD en USD (entero)' })
  vdUsd!: number;

  /** Tipo de cambio USD/CLP (mantiene decimales) */
  @ApiProperty({ example: 951.78, description: 'Tipo de cambio USD/CLP' })
  tc!: number;

  /** Valor declarado en CLP (entero sin decimales) */
  @ApiProperty({ example: -90419, description: 'VD en CLP (entero)' })
  vdClp!: number;
}

export class LiquidacionVdExcelTotalsDto {
  @ApiProperty({ example: 5 })
  totalContenedores!: number;

  /** Total VD en USD (entero sin decimales) */
  @ApiProperty({ example: 2121, description: 'Total VD USD (entero)' })
  totalVdUsd!: number;

  /** Total VD en CLP (entero sin decimales) */
  @ApiProperty({ example: 2058429, description: 'Total VD CLP (entero)' })
  totalVdClp!: number;
}

export class LiquidacionVdExcelResponseDto {
  @ApiProperty({ type: [LiquidacionVdExcelRowDto] })
  rows!: LiquidacionVdExcelRowDto[];

  @ApiProperty({ type: LiquidacionVdExcelTotalsDto })
  totals!: LiquidacionVdExcelTotalsDto;
}
